<template>
  <div class="wholeContext preLoad">
    <app-sidebar></app-sidebar>
    <app-header-authorized></app-header-authorized>
    <div class="appContext main" :class="{ layerAble: futureFlag }">
      <vue-agile :options="myOptions">
        <div class="slide" v-if="IS_LOGIN">
          <div class="slide_item">
            <div class="si_content" v-if="this.resvFlag === 'future'">
              <div class="si_wrap" @click="mainBanner()">
                <div class="si_text">
                  <h2>{{ GET_USERNAME }}님의</h2>
                  <h2>진료예약일</h2>
                  <div class="si_date">
                    <p>
                      {{ reservationDate | moment("YY.MM.DD") }}
                      <b>{{ dayLabel }}</b>
                    </p>
                  </div>
                </div>
                <div class="si_imgWrap">
                  <img src="@/assets/images/main_cn.svg" />
                </div>
              </div>
            </div>
            <div class="si_content above" v-else>
              <div class="si_text">
                <h3><b>갑상선-두경부외과 검사와 수술에 특화된</b></h3>
                <h3>땡큐서울의원-갑상선외과-내분비내과</h3>
              </div>
              <div class="si_wrap" @click="mainBanner()">
                <div class="si_imgWrap">
                  <img src="@/assets/images/main_cn.svg" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="slide" v-else>
          <div class="slide_item">
            <div class="si_content">
              <div class="si_wrap" @click="mainBanner()">
                <div class="si_text">
                  <h3 v-text="getBanner.subContent1">누적 수술/시술</h3>
                  <h3>
                    <b>{{ getBanner.subContent2 }}</b>
                  </h3>
                  <h3 v-text="getBanner.subContent3">누적 초음파 조직검사</h3>
                  <h3>
                    <b>{{ getBanner.subContent4 }}</b>
                  </h3>
                  <div class="si_post">
                    <p>{{ getBanner.subContent5 }}</p>
                  </div>
                </div>
                <div class="si_imgWrap">
                  <img src="@/assets/images/main_cn.svg" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </vue-agile>
      <div class="mainBtnWrap" @click="linkResv()">
        <div class="buttonLL">
          <button type="button">
            <img src="@/assets/images/main-btn-logo.svg" />
            <p>예약하기</p>
          </button>
        </div>
      </div>
      <div class="container main">
        <div class="area_wrap">
          <div class="shortcut_view">
            <ul class="sv_list">
              <div class="sv_list_item">
                <li class="sv_item">
                  <router-link to="/reservation/reservationConfirm">
                    <div class="sv_imgWrap">
                      <img src="@/assets/images/main_cn1.svg" />
                    </div>
                    <div class="sv_text">
                      <span>예약 조회</span>
                    </div>
                  </router-link>
                </li>
                <li class="sv_item">
                  <router-link to="/checkup/checkupList">
                    <div class="sv_imgWrap">
                      <img src="@/assets/images/main_cn2.svg" />
                    </div>
                    <div class="sv_text">
                      <span>검사결과 조회</span>
                    </div>
                  </router-link>
                </li>
              </div>
              <div class="sv_list_item">
                <li class="sv_item">
                  <router-link to="/surgery/SurgeryReservationList">
                    <div class="sv_imgWrap">
                      <img src="@/assets/images/main_cn3.svg" />
                    </div>
                    <div class="sv_text">
                      <span>수술(예정)관리</span>
                    </div>
                  </router-link>
                </li>
                <li class="sv_item">
                  <router-link to="/certificateList">
                    <div class="sv_imgWrap">
                      <img src="@/assets/images/main_cn4.svg" />
                    </div>
                    <div class="sv_text">
                      <span>제증명 발급</span>
                    </div>
                  </router-link>
                </li>
              </div>
            </ul>
          </div>
          <div class="hyperLinkArea">
            <div class="itemWrap">
              <div class="item">
                <a href="https://cafe.naver.com/thanqseoul" target="_blank"
                  >온라인 상담 및 수술후기</a
                >
              </div>
              <div class="item">
                <a href="https://thanqseoul.modoo.at/" target="_blank"
                  >병원 홈페이지 둘러보기</a
                >
              </div>
            </div>
            <div class="logoSection">
              <img src="@/assets/images/main_center.png" />
            </div>
          </div>
          <div class="preview_board">
            <div class="pb_title">
              <p>공지사항</p>
              <router-link to="/noticeList">
                <img src="@/assets/images/+_cn.svg" />
              </router-link>
            </div>
            <div class="pb_content" v-for="(n, i) in order" :key="i">
              <div class="pb_item">
                <p>공지</p>
                <span v-text="n.title" @click.prevent="goDetail(n.id)"
                  >코로나 바이러스 감염증 -19 확산에 따른 정부 지침 공지</span
                >
              </div>
            </div>
          </div>
          <a href="https://thanq.kr" target="_blank">
            <div class="copy">
              <span>https://thanq.kr</span>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div class="chat_btn_wrap" v-show="false">
      <div class="cb_txt_area">
        <div class="cb_close pointer" @click="closeChatBtn">
          <img src="@/assets/images/cb_x.svg" alt="" />
        </div>
        <div class="cb_title">안녕하세요 땡큐 챗봇입니다.</div>
      </div>
      <div class="cb_float_btn pointer" @click.prevent="goChatbot()">
        <img src="@/assets/images/chatbot_cn.svg" />
      </div>
    </div>
    <add-popup v-if="checkPopup" :popupSet="popupSet" />
    <chatbot v-if="checkChat" />
  </div>
</template>
<script>
import AppHeaderAuthorized from '@/components/AppHeaderAuthorized'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import { VueAgile } from 'vue-agile'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { getCookie, removeCookie, setCookie } from '../utils/cookieNew'
import Chatbot from '../components/Chatbot'
import { gsap } from 'gsap'
import EventBus from '../utils/bus'
import errorParser from '@/utils/error-parser'
export default {
  name: 'MainPage',
  data () {
    return {
      setCount: false,
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        cancelBtnText: '취소',
        count: 'actionBtn',
        prevLink: '/reservation/selectDisease',
        closeType: 'close'
      },
      transDate: {
        headerName: '메인화면',

        progressNum: '75%',
        chapterNum: 3,
        prevUrl: '/'
      },
      loadedContent: false,
      reservationDate: '',
      noticeList: [],
      logOn: false,
      resvFlag: '',
      dayLabel: '',
      myOptions: {
        mobileFirst: false,
        slidesToShow: 1,
        centerMode: true,
        autoplay: false,
        navButtons: false,
        dots: false,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              dots: false
            }
          },
          {
            breakpoint: 900,
            settings: {
              navButtons: false,
              dots: false,
              infinite: false
            }
          }
        ]
      },
      futureFlag: false,
      verifyAutoLogic: false,
      view: {
        deviceAct: true,
        versionAct: true,
        autoLoginAct: true
      },
      os: '',
      version: '',
      mobileInfo: {
        result: false
      },
      prePareDone: false
    }
  },
  created () {
    /* 배경색 클래스 추가 */
    this.loading(true)
    document.body.classList.add('mainBody')
    console.log('현위치', document.location.href)
    console.log('MainPage에서 찍은 로그')
    console.log('디바이스 정보 찾기 deviceId ', getCookie('deviceId'))
    console.log('디바이스 정보 찾기 device ', getCookie('device'))
    console.log('디바이스 정보 찾기 fcmToken ', getCookie('fcmToken'))
    console.log('reloadURL Session', sessionStorage.getItem('reloadedURL'))
    console.log(
      'pathToLoadUnAuth Session',
      sessionStorage.getItem('pathToLoadUnAuth')
    )
    console.log(
      'pathFromLoadUnAuth Session',
      sessionStorage.getItem('pathFromLoadUnAuth')
    )
    if (history.pushState !== undefined) {
      console.log('일반 히스토리 진입')
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
    if (getCookie('loginLogicPassed') === undefined) {
      window.callbackDeviceInfo = this.callbackDeviceInfo
      window.callbackAutoLogin = this.callbackAutoLogin
      if (sessionStorage.getItem('userAgent') === null) {
        console.log('디바이스 정보를 못 가져왔음 - 초회 진입 -')
        this.initWebViewDeviceInfo(1, 1, 1)
      }
    } else {
      console.log('로그인 로직 통과함')
      if (getCookie('token') !== undefined) {
        console.log('로그인 로직통과 - 토큰 가지고 있음')
        this.authDataSet()
      } else {
        console.log('로그인 로직통과 - 토큰 없음')
        this.unAuthDataSet()
      }
    }
    EventBus.$on('logoutEvent', (payload) => {
      if (payload) {
        console.log('로그아웃 이벤트 수신')
        this.initData()
      }
    })
  },
  mounted () {
    EventBus.$emit('pageAccess', true)
  },
  computed: {
    ...mapGetters([
      'getVersion',
      'GET_PUSH_LIST',
      'GET_RESERVATION_CHECK',
      'getBanner',
      'GET_USERNAME',
      'IS_LOGIN',
      'GET_PASSED_LOGIC',
      'GET_SIDEBAR_OPEN'
    ]),
    ...mapGetters('push', ['getPushCounted']),
    ...mapGetters('notice', ['getNoticeList']),
    ...mapState(['checkPopup', 'checkChat']),
    order () {
      // eslint-disable-next-line no-undef
      const data = _.orderBy(
        this.noticeList,
        ['important', 'code'],
        ['desc', 'desc']
      )
      // data.splice(3)
      // console.log('data:: ', data)
      return data
    }
  },
  methods: {
    ...mapActions([
      'AUTO_LOGIN',
      'VERSION_CHECK',
      'PUSH_LIST',
      'CHECK_RESERVATION_MAIN',
      'BANNER'
    ]),
    ...mapActions('notice', ['NOTICE_LIST_MAIN']),
    ...mapMutations([
      'SET_DEVICE_PUSHKEY',
      'SET_DEVICE_DEVICEID',
      'SET_DEVICE_APPVERSION',
      'SET_DEVICE_DEVICE',
      'loading',
      'SET_POPUP',
      'SET_RESERVATION_CHECK',
      'SET_CHAT',
      'SET_PASSED_LOGIC'
    ]),
    ...mapMutations('push', ['SET_PUSHCOUNTED']),
    initWebViewDeviceInfo (device, version, autoLogin) {
      if (/thanqApp/.test(navigator.userAgent)) {
        if (device !== 1) {
          this.view.deviceAct = false
        }
        if (version !== 1) {
          this.view.versionAct = false
        }
        if (autoLogin !== 1) {
          this.view.autoLoginAct = false
        }
        console.log('앱에게 디바이스 프로토콜 진입을 요청')
        sessionStorage.setItem('userAgent', 'mobile')
        document.location.href = 'thanq://getDeviceInfo'
      } else {
        console.log('모바일 프로토콜로 진입하지 않음, 인증절차 패스')
        sessionStorage.setItem('userAgent', 'pc')
        this.unAuthDataSet()
        setCookie('loginLogicPassed', true, { secure: true, expires: 30 })
        // this.SET_PASSED_LOGIC(true)
        return false
      }
    },
    callbackDeviceInfo (getDeviceData) {
      console.log('콜백디바이스 인포 진입')
      if (getDeviceData !== '') {
        const deviceDataSet = JSON.parse(getDeviceData)
        const fcmToken = deviceDataSet.fcmToken
        const deviceId = deviceDataSet.deviceId
        const appVersion = deviceDataSet.appVersion
        const device = deviceDataSet.device
        console.log(
          '=== 콜백디바이스인포에서 가져온 CallbackDeviceInfo 정보 ==='
        )
        console.log(' fcmToken :', fcmToken)
        console.log(' deviceId :', deviceId)
        console.log(' appVersion :', appVersion)
        console.log(' device :', device)
        this.setDeviceInfoData(fcmToken, deviceId, appVersion, device)
      } else {
        console.log('콜백디바이스 인포에서 에러남')
        // 콜백디바이스 인포 에러일떄를 정리하면 좋을 듯
      }
    },
    async setDeviceInfoData (fcmToken, deviceId, appVersion, device) {
      setCookie('fcmToken', fcmToken, { secure: true, expires: 30 })
      setCookie('deviceId', deviceId, { secure: true, expires: 30 })
      setCookie('appVersion', appVersion, { secure: true, expires: 30 })
      setCookie('device', device, { secure: true, expires: 30 })
      this.$store.commit('SET_DEVICE_PUSHKEY', fcmToken)
      this.$store.commit('SET_DEVICE_DEVICEID', deviceId)
      this.$store.commit('SET_DEVICE_APPVERSION', appVersion)
      this.$store.commit('SET_DEVICE_DEVICE', device)
      console.log('콜벡디바이스인포 저장됨')
      if (this.view.versionAct) {
        await this.versionCheck()
      }
      if (this.view.autoLoginAct) {
        if (this.mobileInfo.result) {
          console.log(
            '버전체크결과 권고 또는 무시사항으로 오토로그인 로직, view렌더 실행'
          )
          await this.initWebViewAutoLogin()
        } else {
          console.log('버전체크결과 강제로 오토로그인 로직, view렌더 미실행')
        }
      }
    },
    async versionCheck () {
      if (getCookie('device') !== undefined) {
        console.log('모바일 진입')
        console.log('os: ' + getCookie('device'))
        console.log('version: ' + getCookie('appVersion'))
        this.os = getCookie('device')
        this.version = getCookie('appVersion')
        if (this.os === 'A') {
          this.os = 'Android'
        } else if (this.os === 'I') {
          this.os = 'iOS'
        }
        const payload = {
          os: this.os,
          version: this.version
        }
        console.log('payload: ', payload)
        console.log('payload.os: ', payload.os)
        console.log('payload.version: ', payload.version)
        try {
          await this.VERSION_CHECK(payload).then(() => {
            console.log('check:', this.getVersion.check)
            console.log('os:', this.getVersion.os)
            console.log('version:', this.getVersion.version)
            console.log('option:', this.getVersion.option)
            console.log('url:', this.getVersion.url)
            if (this.getVersion.option === 1) {
              this.SET_POPUP_HEADER_MAIN(true)
              this.popupSet.count = 'mobileAction'
              this.popupSet.closeType = 'close'
              this.popupSet.content =
                '업데이트 버전이 있습니다. 확인을 누르면 업데이트 하실 수 있습니다.'
              this.popupSet.mobileLink = this.getVersion.url
              this.mobileInfo.result = true
            } else if (this.getVersion.option === 2) {
              this.SET_POPUP_HEADER_MAIN(true)
              this.popupSet.count = 'mobileAction'
              this.popupSet.closeType = 'mobileAction'
              this.popupSet.content =
                '최신 버전으로 업데이트 후 앱 사용이 가능합니다.'
              this.popupSet.mobileLink = this.getVersion.url
              this.mobileInfo.result = false
            } else if (this.getVersion.option === 0) {
              console.log('현재 버전의 옵션은: ', this.getVersion.option)
              this.mobileInfo.result = true
            } else {
              console.log('알 수 없는 버전임 (버전체크로 감지못함)')
              console.log('현재 버전의 옵션은: ', this.getVersion.option)
              this.mobileInfo.result = false
            }
          })
        } catch (e) {
          console.log('error: ', e)
          console.log('버전체크 API 실패')
          this.mobileInfo.result = false
        } finally {
        }
      } else {
        console.log(
          '버전체크 시도했으나 디바이스 정보가 없음 (빠지면 안되는 오류)'
        )
        this.mobileInfo.result = false
      }
    },
    async initWebViewAutoLogin () {
      if (/thanqApp/.test(navigator.userAgent)) {
        console.log('앱에게 오토로그인 프로토콜 진입을 요청')
        await this.callbackAutoLogin()
        await this.executionAutoProtocol()
        await this.autoLoginFalse()
      }
    },
    async executionAutoProtocol () {
      document.location.href = 'thanq://autoLogin'
    },
    async autoLoginFalse () {
      console.log('로그인 마지막 진입')
      setTimeout(() => {
        if (this.verifyAutoLogic) {
          console.log('오토로그인 진행불가로 메인 로딩')
          this.unAuthDataSet()
          setCookie('loginLogicPassed', true, { secure: true, expires: 30 })
        }
      }, 1000)
    },
    async callbackAutoLogin (getAutoLogin) {
      console.log('콜백오토로그인의 값', getAutoLogin)
      console.log('콜백 오토로그인 진입')
      if (getAutoLogin !== undefined) {
        this.verifyAutoLogic = false
        const deviceDataSet = JSON.parse(getAutoLogin)
        const deviceId = deviceDataSet.deviceId
        const fcmToken = deviceDataSet.fcmToken
        const sessionToken = deviceDataSet.sessionToken
        console.log('앱에서준 sessionToken', sessionToken)
        setCookie('token', sessionToken, { secure: true, expires: 30 })
        await this.setAutoLoginData(deviceId, fcmToken, getCookie('device'))
      } else {
        console.log('오토로그인 객체값이 없어서 verifyAutoLogic을 트루로')
        this.verifyAutoLogic = true
      }
    },
    async setAutoLoginData (deviceId, fcmToken, device) {
      console.log('오토로그인 API 시작점 진입')
      console.log('세션URL 확인1', sessionStorage.getItem('pathToLoadAuthPre'))
      console.log('세션URL 확인2', sessionStorage.getItem('pathToLoadAuth'))
      console.log('세션URL 확인3', sessionStorage.getItem('pathToLoadUnAuth'))
      try {
        const userData = {
          deviceId: deviceId,
          fcmToken: fcmToken,
          device: device
        }
        await this.AUTO_LOGIN(userData).then(() => {
          console.log('오토로그인 성공후 .then에서 flag값 변경')
          this.patchPushList()
          this.authDataSet()
          setCookie('loginLogicPassed', true, { secure: true, expires: 30 })
        })
      } catch (error) {
        removeCookie('token')
        console.log('오토로그인 API 실패:')
        console.log('오토로그인 error: ', error)
        console.log('오토로그인 error Name: ', error.name)
        console.log('error :', error)
        if (error.status !== 401) {
          if (error.name !== 'NavigationDuplicated') {
            console.log('오토로그인 에러에 진입함')
            console.log('가져온 deviceId', deviceId)
            console.log('가져온 fcmToken', fcmToken)
            console.log('가져온 device', device)
            this.unAuthDataSet()
            setCookie('loginLogicPassed', true, { secure: true, expires: 30 })
            // this.SET_PASSED_LOGIC(true)
            return false
          } else {
            console.log('오토로그인 펄스에서 이 에러에 빠지면 안되요..')
            return false
          }
        } else {
          this.unAuthDataSet()
          setCookie('loginLogicPassed', true, { secure: true, expires: 30 })
          await this.$router.push('/login')
          return false
        }
      }
    },
    async patchPushList () {
      console.log('푸시리스트 api 실행 (전역앱에서)')
      try {
        await this.PUSH_LIST().then(() => {
          this.patchData()
        })
      } catch (error) {
        console.log(
          '푸시실패 처리 후 이동경로',
          sessionStorage.getItem('pathToLoadAuthPre')
        )
        console.log('푸시리스트 api 실패함')
      }
    },
    patchData () {
      const InactivityArray = []
      let count = 0
      for (let i = 0; i < this.GET_PUSH_LIST.length; i++) {
        // 읽지않은 푸시 담기
        if (this.GET_PUSH_LIST[i].is_read === false) {
          InactivityArray.push(String(i))
          // 뱃지카운트 계산해
          count++
        }
      }
      console.log('뱃지카운트 구하는데 진입')
      console.log('찾아온 뱃지카운트', count)
      this.SET_PUSHCOUNTED(count)
    },
    unAuthDataSet () {
      console.log('검증로직 - 권한없는 데이터셋')
      this.initData()
      this.fetchData()
    },
    authDataSet () {
      console.log('검증로직 - 권한있는 데이터셋')
      this.initData()
      this.complexData()
    },
    initData () {
      this.futureFlag = false
      this.resvFlag = ''
    },
    async complexData () {
      await this.pressReservation()
      await this.fetchData()
    },
    linkResv () {
      if (getCookie('token') === undefined) {
        this.SET_POPUP(true)
        this.popupSet.content = '로그인 후 이용 가능한 서비스입니다.'
        this.popupSet.cancelBtnText = '로그인'
        this.popupSet.confirmBtnText = '회원가입'
        this.popupSet.count = 'triple'
        this.popupSet.anotherBtnText = '전화예약상담'
        this.popupSet.nextLink = '/telReservation_step1'
      } else {
        this.flagToWarp()
      }
    },
    getDay () {
      // 요일이름 구하기
      const week = []
      week.push('일', '월', '화', '수', '목', '금', '토')
      const day = new Date(this.reservationDate)
      const dayName = day.getDay()
      const todayLabel = week[dayName]
      this.dayLabel = todayLabel
    },
    async bannerAct () {
      try {
        await this.BANNER()
      } catch (error) {
        console.log('error :', error)
        console.log('메인배너 에러에 진입함!')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    async noticeAct () {
      try {
        await this.NOTICE_LIST_MAIN().then(() => {
          this.noticeList = this.getNoticeList
          console.log('공지사항', this.getNoticeList.length)
        })
      } catch (error) {
        console.log('error :', error)
        console.log('공지사항 에러에 진입함!')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    async loadingDone () {
      this.prePareDone = true
      this.loading(false)
    },
    async fetchData () {
      console.log('검증로직 - 패치데이타 진입')
      await this.bannerAct()
      await this.noticeAct()
      await this.loadingDone()
    },
    mainBanner () {
      if (this.resvFlag === 'future') {
        this.$router.push('/reservation/reservationConfirm')
      } else {
        this.$router.push('/mainBanner')
      }
    },
    goChatbot () {
      this.$router.push('/chatbot')
    },
    goUrl () {
      const url = (location.href = 'https://thanq.kr/')
      return url
    },
    async goDetail (code) {
      console.log('code: ', code)
      await this.$router.push(`/notice/${code}`)
    },
    goPage () {
      location.href = 'https://cafe.naver.com/thanqseoul'
    },
    flagToWarp () {
      if (this.resvFlag === 'first') {
        this.$router.push('/reservation/explain')
      } else {
        this.$router.push('/reservation/reCare')
      }
    },
    async pressReservation () {
      try {
        await this.CHECK_RESERVATION_MAIN().then(() => {
          console.log(
            '이거 체크해줘',
            this.GET_RESERVATION_CHECK.flag === undefined
          )
          console.log('본체', this.GET_RESERVATION_CHECK)
          console.log('길이', this.GET_RESERVATION_CHECK.length)
          if (this.GET_RESERVATION_CHECK.length !== undefined && this.GET_RESERVATION_CHECK[0] !== undefined) {
            if (this.GET_RESERVATION_CHECK[0].flag === 'first') {
              // this.$router.push('/reservation/explain')
              this.resvFlag = 'first'
              this.futureFlag = true
            } else if (this.GET_RESERVATION_CHECK[0].flag === 'future') {
              this.resvFlag = 'future'
              this.reservationDate = this.GET_RESERVATION_CHECK[0].reservationDate
              this.futureFlag = false
              this.getDay()
            } else {
              // this.$router.push('/reservation/reCare')
              this.resvFlag = 'others'
              this.futureFlag = true
            }
          } else {
            if (this.GET_RESERVATION_CHECK.flag !== undefined) {
              if (this.GET_RESERVATION_CHECK.flag === 'first') {
                //  this.$router.push('/reservation/explain')
                this.resvFlag = 'first'
                this.futureFlag = true
              } else if (this.GET_RESERVATION_CHECK.flag === 'future') {
                this.resvFlag = 'future'
                this.reservationDate = this.GET_RESERVATION_CHECK.reservationDate
                this.futureFlag = false
                this.getDay()
              } else {
                // this.$router.push('/reservation/reCare')
                this.resvFlag = 'others'
                this.futureFlag = true
              }
            } else {
              this.resvFlag = 'first'
              this.futureFlag = true
            }
          }
        })
      } catch (error) {
        console.log('메인 예약체크 API에서 에러남')
        console.log('error', error)
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    callPrev () {
      const currentLocation = document.location.href
      const mainLocate = currentLocation.substring(
        currentLocation.length,
        currentLocation.length - 1
      )
      console.log('메인로케이트', mainLocate)
      console.log('setCount', this.setCount)
      if (sessionStorage.getItem('pathToLoadUnAuth') === mainLocate) {
        history.go(1)
        if (this.setCount) {
          if (getCookie('device') === 'A' && this.GET_SIDEBAR_OPEN === false) {
            const url = 'thanq://appClose'
            this.SET_POPUP(true)
            this.popupSet.count = 'mobileAction'
            this.popupSet.closeType = 'close'
            this.popupSet.content = '앱을 종료하시겠습니까?'
            this.popupSet.mobileLink = url
          }
        }
        this.setCount = true
      }
      // 클로즈 함수 구현
    },
    closeChatBtn () {
      gsap.to('.cb_txt_area', 0.2, {
        left: 280,
        width: 0,
        opacity: 0
      })
    }
  },
  beforeDestroy () {
    this.SET_POPUP(false)
    this.setCount = false
    this.initData()
    this.prePareDone = false
    EventBus.$off('pageAccess')
    /* 배경색 클래스 제거 */
    document.body.classList.remove('mainBody')
  },
  components: {
    Chatbot,
    AppHeaderAuthorized,
    AppSidebar,
    AddPopup,
    VueAgile
  }
}
</script>

<style lang="scss" scoped>
.link_item {
  &.clear {
    a {
      color: blue;
    }
  }
  &.error {
    a {
      color: red;
    }
  }
}
</style>
